var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"employee-slider"},_vm._l((_vm.starterImages),function(image,index){return _c('div',{key:'image'+index,staticClass:"image-wrapper",class:{'active': _vm.currentImageIndex === index},style:({backgroundImage: ("url(" + (image.src) + ")")})})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a608387","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmployeeSlider/EmployeeSlider.vue
// module id = null
// module chunks = 